import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  data: null,
  tenureKpis: [],
  creditUtilizationTrend: { data: [], isFetching: false },
  isFetching: false,
};

const creditDashboard = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.CREDIT_DASHBOARD_DATA:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_CREDIT_DASHBOARD_DATA:
      return { ...initialState };
    default:
      return state;
  }
};

export default creditDashboard;
